export type AgentEditorPresence = {
    id?: string;
    name?: string;
    email?: string | null;
    connection_id?: string;
    joined_at?: string;
    last_seen_at?: string;
    status?: string;
};

export function pickMostRecentEditor(
    editors: AgentEditorPresence[]
): AgentEditorPresence | undefined {
    if (!editors.length) return undefined;
    return [...editors].sort((a, b) => {
        const aTs = a.last_seen_at || a.joined_at || '';
        const bTs = b.last_seen_at || b.joined_at || '';
        if (aTs === bTs) return 0;
        return aTs < bTs ? 1 : -1;
    })[0];
}

function presenceIdentity(editor: AgentEditorPresence): string {
    if (editor.id) return `id:${editor.id}`;
    if (editor.email) return `email:${editor.email.toLowerCase()}`;
    if (editor.connection_id) return `connection:${editor.connection_id}`;
    return '';
}

export function dedupeEditorPresence(
    editors: AgentEditorPresence[]
): AgentEditorPresence[] {
    const editorsByIdentity = new Map<string, AgentEditorPresence>();

    editors.forEach((editor, index) => {
        const identity = presenceIdentity(editor) || `unknown:${index}`;
        const existing = editorsByIdentity.get(identity);
        if (!existing) {
            editorsByIdentity.set(identity, editor);
            return;
        }

        const mostRecent = pickMostRecentEditor([existing, editor]);
        if (mostRecent) {
            editorsByIdentity.set(identity, mostRecent);
        }
    });

    return Array.from(editorsByIdentity.values()).sort((a, b) => {
        const aTs = a.joined_at || '';
        const bTs = b.joined_at || '';
        if (aTs === bTs) return 0;
        return aTs < bTs ? -1 : 1;
    });
}
